import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  padding-top: 5rem;
  background: ${({ theme }) => theme.colors.background};
  overflow: 'hidden';

  @media (max-width: 767px) {
    flex-direction: column;
  }

  @media (max-width: 500px) {
    padding-top: 0.2rem;
  }
`;

interface CardSolicitationDemandProps {
  condition: boolean;
}

export const CardSolicitationDemand = styled.div<CardSolicitationDemandProps>`
  background-color: ${(props) =>
    props.condition ? ({ theme }) => theme.colors.error_200 : ({ theme }) => theme.colors.tertiary};
  display: flex;
  width: 100%;
  max-width: 8rem;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem;
  border-radius: 0.5rem;
  box-shadow: 0px 1px 9px #00000029;

  .card-info span {
    color: ${({ theme }) => theme.colors.secondary};
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;

export const ContainerProfile = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  align-items: center;

  .containerSolicitation {
    width: 95%;
    box-shadow: 0px 1px 9px #00000029;
    border-radius: 1rem;
  }

  .informationMobile {
    display: none;
  }

  .information {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    gap: 0.3rem;
  }

  @media (max-width: 990px) {
    width: 40%;
  }

  @media (max-width: 767px) {
    width: 100%;
    margin-bottom: 0.2rem;
    flex-direction: row;
    gap: 0;

    .containerSolicitation {
      display: none;
    }
  }

  @media (max-width: 500px) {
    flex-direction: column;
    gap: 0.2rem;

    .informationMobile {
      display: block;
      width: -webkit-fill-available;

      .showMore {
        display: flex;
        justify-content: center;
        margin: 1rem 0;

        button {
          background-color: transparent;
          border: none;
          display: flex;
          align-items: self-end;
          gap: 0.2rem;
          font-size: 1.2rem;
          color: ${({ theme }) => theme.colors.gray};

          svg {
            font-size: 20px;
          }
        }
      }
    }

    .information {
      display: none;
    }
  }
`;

export const ContainerPublication = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ContainerServices = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Commitments = styled.div`
  width: 60%;
  padding: 0 0.5rem 0 0.5rem;

  h1 {
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 1.2rem;
    font-weight: 600;
  }

  .feedback {
    display: flex;
    align-items: center;
    margin-left: 520px;
    margin-top: -3.75rem;
    margin-bottom: 1.875rem;
    min-width: 10rem;

    /* @media (max-width: 1400px) {
        margin-left: 0;
        margin-top: -3.75rem;
        margin-bottom: 1.875rem;
        margin-right: 0;
    } */


    @media (max-width: 1350px) {
      margin-left: -1rem;
      margin-top: -3.75rem;
      margin-bottom: 1.875rem;
      /* margin-right: 1rem; */
    }
    
    @media (max-width: 1285px) {
        margin-left: -3rem;
        margin-top: -3.75rem;
        margin-bottom: 1.875rem;
        /* margin-right: 1rem; */
    }

    @media (max-width: 1200px) {
        margin-left: -3rem;
        margin-top: -3.75rem;
        margin-bottom: 1.875rem;
        /* margin-right: 1rem; */
    }

    .btn-feedback {
      margin-left: -4rem;
      margin-right: 0.3rem;
      background-color: ${({ theme }) => theme.colors.primary};
      font-size: 1.2rem;
      color: white;
      padding: 0 0.5rem;
      border: none;
      border-radius: 0.5rem;
      cursor: pointer;
      transition: background-color 0.3s;

      &:hover {
        background-color: ${({ theme }) => theme.colors.tertiary};
        color: ${({ theme }) => theme.colors.secondary};
        border: none;
      }

      /* @media (max-width: 1350px) {
        margin-left: 8vw;
      } */

      @media (max-width: 1350px) {
        margin-left: 9rem;
      }
    }
  }

  .calendar-time {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    margin: 5px 0 10px 0;

    .rmdp-wrapper {
      z-index: 0 !important;
    }

    .rmdp-shadow {
      box-shadow: 0px 1px 9px #00000029 !important;
    }

    .rmdp-wrapper .rmdp-top-class .rmdp-calendar .rmdp-header {
      background-color: ${({ theme }) => theme.colors.primary};

      div {
        color: ${({ theme }) => theme.colors.background_white};
        //Cor de fundo do cabeçalho do calendário
        .rmdp-arrow-container {
          background-color: ${({ theme }) => theme.colors.primary};
          //Cor das setas do cabeçalho
          .rmdp-arrow {
            border: solid ${({ theme }) => theme.colors.background_white};
            border-width: 0 2px 2px 0;
          }
        }
      }
    }

    .rmdp-week-day {
      color: ${({ theme }) => theme.colors.black};
    }

    //Retirada bordar do calendário
    .rmdp-prime.rmdp-wrapper {
      border: none;
    }

    //Cor do dia selecionado
    .rmdp-day.rmdp-selected span:not(.highlight) {
      background-color: lightgray !important;
      color: #000 !important;
    }

    //Cor ao passar o mouse nos dias do calendário
    .rmdp-day span:hover {
      background-color: lightgray !important;
      color: #000 !important;
      opacity: 0.5 !important;
    }

    /* Estilo para os dias com compromissos */
    .rmdp-day.has-appointment span {
      background-color: #e0f7d6 !important;
      color: #000 !important;
      border-radius: 50% !important;
    }

    /* Estilo para os dias desabilitados (dias que não fazem parte do mês selecionado) */
    .rmdp-day.rmdp-disabled span:hover {
      background-color: transparent !important;
    }

    .rmdp-day.rmdp-today span {
      background-color: ${({ theme }) => theme.colors.tertiary_500} !important;
    }

    .table {
      margin-left: 0.5rem;
      border-radius: 1rem;
      box-shadow: 0px 1px 9px #00000029;
      padding: 0.2rem 0;
      background-color: ${({ theme }) => theme.colors.background_white};
      overflow: scroll;

      tr:nth-child(odd) {
        background-color: ${({ theme }) => theme.colors.background_white};
      }

      tr:nth-child(even) {
        background-color: ${({ theme }) => theme.colors.background_white};
      }

      tr {
        min-height: 4rem;
        max-height: 4rem;
      }

      td {
        padding: 0.5rem;
        min-height: 4rem;
        max-height: 4rem;

        .containerCard {
          display: flex;
          align-items: center;
          gap: 0.5rem;

          .cardSolicitationDemand {
            background-color: ${({ theme }) => theme.colors.error_200};
            display: flex;
            width: 100%;
            max-width: 8rem;
            align-items: center;
            justify-content: space-between;
            padding: 0.6rem;
            border-radius: 0.5rem;
            box-shadow: 0px 1px 9px #00000029;

            .card-info span {
              color: ${({ theme }) => theme.colors.secondary};
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }

          .cardDemandProposal {
            background-color: ${({ theme }) => theme.colors.yellow_200};
            display: flex;
            width: 100%;
            max-width: 8rem;
            align-items: center;
            justify-content: space-between;
            padding: 0.6rem;
            border-radius: 0.5rem;
            box-shadow: 0px 1px 9px #00000029;

            .card-info span {
              color: ${({ theme }) => theme.colors.secondary};
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
        }
      }

      .hour {
        width: 1.5rem;
      }
    }

    @media (min-width: 1200px) and (max-width: 1400px) {
      .table {
        max-width: 18rem !important;
      }
    }

    @media screen and (max-width: 1200px) {
      flex-direction: column;

      .rmdp-prime {
        width: 100%;

        .rmdp-calendar {
          width: 100%;

          div {
            .rmdp-day-picker > div {
              width: 100%;
            }
          }
        }
      }

      .table {
        margin-top: 10px;
        margin-left: 0px;
      }
    }
  }

  @media (max-width: 990px) {
    display: none;
  }
`;
